module.exports = __webpack_public_path__ + "static/media/Engaging_Business_Transparent_logo.996bf960.png";